import React from 'react';
import { arrayOf, bool, func, number } from 'prop-types';
import cx from 'classnames';
import coord from 'propTypes/coord';
import PathSuggestionTooltip from '../PathSuggestionTooltip';
import styles from './PathSuggestions.scss';

export default function PathSuggestion({
  path,
  isSelected,
  onSelect,
  distance,
  expectedTravelTime,
}) {
  // eslint-disable-next-line global-require
  const { FeatureGroup, Polyline } = require('react-leaflet');

  return (
    <FeatureGroup onClick={onSelect}>
      <Polyline
        classNames={cx(styles.outline, {
          [styles.selected]: isSelected,
        })}
        positions={path}
      />
      {isSelected && <Polyline className={styles.underline} positions={path} />}
      <Polyline
        className={cx(styles.line, {
          [styles.selected]: isSelected,
        })}
        positions={path}
      />
      <PathSuggestionTooltip distance={distance} expectedTravelTime={expectedTravelTime} />
    </FeatureGroup>
  );
}

PathSuggestion.propTypes = {
  path: arrayOf(coord).isRequired,
  distance: number.isRequired,
  expectedTravelTime: number.isRequired,
  isSelected: bool.isRequired,
  onSelect: func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Map/CreateSegment/PathSuggestion/index.js